import UnauthorizedPage from "pages/UnauthorizedPage";
import Error from "./Error";
import Loading from "./loading/Loading";
import NoData from "./NoData";
import Translate from "./Translate";

export type ComponentStateTypes = 'saving' | 'loading' | 'nodata' | 'error' | string | React.ReactNode | undefined | null | 'no-permission';

type ComponentStatePropsType = {
    state: ComponentStateTypes
    children: React.ReactNode | React.ReactNode[] | (() => React.ReactNode | React.ReactNode[])
}

const ComponentState = (props: ComponentStatePropsType) => {
    let render: React.ReactNode;
    if(props.state === 'loading'){
        render = <Loading />
    } else if(props.state === 'nodata') {
        render = <NoData />
    } else if(props.state === 'error') {
        render = <Error message={'error'} />
    } else if(typeof props.state == 'string' && props.state.startsWith('no-permission')) {
        render = <UnauthorizedPage reason={props.state} />
    } else if(typeof props.state === 'string' && props.state && props.state !== 'saving') {
        render = <Translate i18nKey={props.state} />
    } else if(props.state && props.state !== 'saving') {
        render = <>{props.state}</>;
    } else {
        if(typeof props.children == 'function') {
            render = <>{props.children()}</>;
        } else render = <>{props.children}</>;
    }

    return render;
}

export default ComponentState;
